<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="!params")
    .settings__form(v-else)
        .settings__field
            label.settings__label
                | {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}
            .settings__field-body
                cs-checkbox.settings__button(
                    v-model="params.operations.multiply",
                    :disabled="params.operations.multiply",
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_operationMultiply') }}
                cs-checkbox.settings__button(
                    v-model='params.operations.divide',
                    :disabled="params.operations.divide",
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_operationDivide') }}
        .settings__field(v-if="params.operations.multiply" )
            label.settings__label
                | {{ $i18n.t('trainer.trainer_gameFormSetting_extraOperations') }}
            .settings__field-body
                cs-checkbox.settings__button(
                    v-model="params.extraOperations.abCrossAc",
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_rule') }} AB*AC
                cs-checkbox.settings__button(
                    v-model='params.extraOperations.mirror.isChosen',
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_mirror') }}
                cs-checkbox.settings__button(
                    v-model='params.extraOperations.rule101.isChosen',
                    @change="setInitialRule101Checkbox",
                )
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_rule') }} 101
        template(v-if="params.extraOperations.mirror.isChosen")
            .form__field-body.multiplication-division.sub-operations.sub-operation
                cs-checkbox(
                    v-for="digit in 9"
                    v-model="params.extraOperations.mirror.digits[digit - 1]"
                    @change="resetMirrorCheckboxes(digit)"
                )
                    |  {{ getMirrorNumberAccordingToRightCapacity(digit) }}
        template(v-if="params.extraOperations.rule101.isChosen")
            .sub-operations
                .form__field-body.multiplication-division.sub-operation
                    cs-checkbox(
                        v-model="params.extraOperations.rule101['101']"
                        @change="resetOtherRule101Checkboxes('101')"
                        :disabled="!params.digitCapacity.left.includes(2)"
                    )
                        | 101
                .form__field-body.multiplication-division.sub-operation
                    cs-checkbox(
                        v-model="params.extraOperations.rule101['1001']"
                        @change="resetOtherRule101Checkboxes('1001')"
                        :disabled="!params.digitCapacity.left.includes(3)"
                    )
                        | 1001
                .form__field-body.multiplication-division.sub-operation
                    cs-checkbox(
                        v-model="params.extraOperations.rule101['10101']"
                        @change="resetOtherRule101Checkboxes('10101')"
                        :disabled="!params.digitCapacity.left.includes(2)"
                    )
                        | 10101
        .settings__field
            .settings__columns
                .settings__column
                    label.settings__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}
                        .select-container(v-if="params.fractions.left")
                    .tabs-container
                        settings-tab.settings__button.settings__button_is-tab(
                            v-for="(value, key) in leftDigitCapacityDisabled",
                            :selected="params.digitCapacity.left && params.digitCapacity.left.includes(+key)",
                            @click.native.prevent="setKey('left', +key)"
                            :key="'left' + key",
                        ) {{ value }}
                .settings__column(v-if="!params.extraOperations.rule101.isChosen" )
                    label.settings__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}
                    .tabs-container
                        settings-tab.settings__button.settings__button_is-tab(
                            v-for="(value, key) in rightDigitCapacityForMultiply",
                            :selected='params.digitCapacity.right && params.digitCapacity.right.includes(+key)',
                            @click.native.prevent="setKey('right', +key)",
                            :disabled="rightDigitCapacityDisabled(key)",
                            :key="'digitCapacities' + key"
                        )
                            | {{ value }}
</template>

<script>
    /*eslint-disable*/
    import { intersection, isEmpty } from "lodash";

    export default {
        props: {
            currentUserParams: {
                type: Object,
                default () {
                    return null;
                }
            }
        },
        data () {
            return {
                params: null,
                numbers: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                digitCapacities: {
                    1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                    2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                    3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                    4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                    5: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                },
            }
        },
        watch: {
            currentUserParams: {
                handler (value) {
                    this.params = value;
                }
            },
            'params.digitCapacity.left': {
                handler (val, oldVal) {
                    if (val[0]) {
                        let mirrorIsOff = !this.params.extraOperations.mirror.isChosen;
                        this.params.numbers = [];
                        this.params.tabulatedValue = false;
                            mirrorIsOff && val[0] < this.params.digitCapacity.right[0] && (this.params.digitCapacity.right[0] = val[0])
                        if (this.params.extraOperations.rule101.isChosen && oldVal) {
                            this.resetOtherRule101Checkboxes();
                            this.setInitialRule101Checkbox();
                        }
                    }
                }
            },
            'params.digitCapacity.right': {
                handler (val) {
                    if (val[0]) {
                        this.params.tabulatedValue = false;
                    }
                }
            },
            'params.tabulatedValue': {
                handler (val) {
                    if (val) {
                        this.params.digitCapacity.right = []
                    }
                }
            },
            'params.numbers': {
                handler (val) {
                    if (val && val.length) {
                        this.params.fractions.left = false;
                        if (+this.params.digitCapacity.right[0] === 1) {
                            this.params.digitCapacity.right = [];
                        }
                    }
                }
            },
            'params.extraOperations.abCrossAc'(val) {
                if (val) {
                    this.resetExtraOperationsCheckboxes();
                    this.params.extraOperations.abCrossAc = true;
                    this.params.digitCapacity.left = [2];
                    this.params.digitCapacity.right = [2];
                } else {
                    this.params.extraOperations.abCrossAc = false;
                }
            },
            'params.extraOperations.rule101.isChosen'(val) {
                const RULE101_ALLOWED_LEFT_CAPACITIES = [2, 3];

                if (val) {
                    this.resetExtraOperationsCheckboxes();
                    this.params.extraOperations.rule101.isChosen = true;
                    this.$validator.detach('right');
                    this.params.digitCapacity.right = [];
                    if (intersection(this.params.digitCapacity.left, RULE101_ALLOWED_LEFT_CAPACITIES).length === 0) {
                        this.params.digitCapacity.left = [2];
                    }
                } else {
                    this.params.extraOperations.rule101.isChosen = false;
                    if (isEmpty(this.params.digitCapacity.right)) {
                        this.params.digitCapacity.right = [1];
                    }
                }
            },
            'params.extraOperations.mirror.isChosen'(val) {
                if (val) {
                    this.resetExtraOperationsCheckboxes();
                    this.params.extraOperations.mirror.isChosen = true;
                } else {
                    this.params.digitCapacity.left[0] < this.params.digitCapacity.right[0]
                    && (this.params.digitCapacity.right[0] = this.params.digitCapacity.left[0]);
                }
            },
            'params.operations.multiply': {
                handler (val) {
                    if (val) {
                        this.params.operations.divide = false;
                    }
                }
            },
            'params.operations.divide': {
                handler (val) {
                    if (val) {
                        this.params.operations.multiply = false;
                        this.resetExtraOperationsCheckboxes();
                        this.params.digitCapacity.left = [3];
                        this.params.digitCapacity.right = [1];
                    }
                }
            },
            rightFractionsDisabled: {
                handler (val) {
                    if (val) {
                        this.params.fractions.right = false;
                    }
                }
            },
            'params.fractions.right': {
                handler (val) {
                    if (val && this.params.tabulatedValue) {
                        this.params.tabulatedValue = false;
                    }
                }
            },
            'params.fractionalPart.left': {
                handler () {
                    this.params.fractionalPart.right = 1;
                }
            }
        },
        methods: {
            getMirrorNumberAccordingToRightCapacity(number) {
                return number.toString().repeat(this.params.digitCapacity.right[0] ?? 1);
            },
            resetMirrorCheckboxes(digit) {
                for (let i = 0; i < 9; i++) {
                    this.params.extraOperations.mirror.digits[i] = false;
                }
                this.params.extraOperations.mirror.digits[digit - 1] = true;
            },
            resetExtraOperationsCheckboxes() {
                this.params.extraOperations.abCrossAc = false;
                this.params.extraOperations.rule101.isChosen = false;
                this.params.extraOperations.mirror.isChosen = false;
            },
            setInitialRule101Checkbox() {
                this.params.extraOperations.rule101[this.params.digitCapacity.left.includes(2) ? '101' : '1001'] = true;
            },
            resetOtherRule101Checkboxes(subRule) {
                this.params.extraOperations.rule101['101'] = false;
                this.params.extraOperations.rule101['1001'] = false;
                this.params.extraOperations.rule101['10101'] = false;

                if (subRule) {
                    this.params.extraOperations.rule101[subRule] = true;
                }
            },
            setNumber (number) {
                if (this.params.numbers.includes(number)) {
                    this.params.numbers.splice(this.params.numbers.indexOf(number), 1);
                } else {
                    this.params.numbers.push(number);
                }
                this.params.digitCapacity.left = [];
            },
            setKey (key, value) {
                if (!this.params.digitCapacity[key].includes(value)) {
                    this.params.digitCapacity[key] = [];
                    this.params.digitCapacity[key].push(value);
                }
            },
            rightDigitCapacityDisabled (index) {
                if (!this.params.extraOperations.mirror.isChosen) {
                    return (this.params.numbers.length === 0 && this.params.digitCapacity.left[0] < index)
                        || (+index === 1 && this.params.numbers.length !== 0);
                } else {
                    return false;
                }
            },
            isDisabled (value) {
                return this.params.numbers.length === 0 && this.params.digitCapacity.left[0] < value
            },
        },
        computed: {
            rightFractionsDisabled () {
                return this.params && (this.params.numbers.length !== 0 || !this.params.fractions.left);
            },
            leftDigitCapacityDisabled () {
                if (this.params.operations.multiply &&
                   (!this.params.extraOperations.abCrossAc
                   && !this.params.extraOperations.rule101.isChosen))
                {
                    return (
                        this.digitCapacities
                    );
                }
                if (this.params.operations.divide) {
                    return Object.fromEntries(
                        Object.entries(this.digitCapacities).slice(2, 4)
                    )
                }
                if (this.params.operations.multiply && this.params.extraOperations.abCrossAc) {
                    return Object.fromEntries(
                        Object.entries(this.digitCapacities).slice(1, 2)
                    )
                }
                if (this.params.operations.multiply && this.params.extraOperations.rule101.isChosen) {
                    return Object.fromEntries(
                        Object.entries(this.digitCapacities).slice(1, 3)
                    )
                }
            },
            rightDigitCapacityForMultiply() {
                if (this.params.operations.multiply && !this.params.extraOperations.abCrossAc) {
                    return this.digitCapacities;
                }
                if (this.params.operations.multiply && this.params.extraOperations.abCrossAc) {
                    return Object.fromEntries(
                        Object.entries(this.digitCapacities).slice(1, 2)
                    )
                }
                if (this.params.operations.divide) {
                    return Object.fromEntries(
                        Object.entries(this.digitCapacities).slice(0, 1)
                    )
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .settings__form {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 25px 10px 15px;
        @include media($xl) {
            padding: 25px 10px;
        }
    }
    .settings__field {
        display: flex;
        justify-content: flex-start;
        @include stack-space($space-base);
    }
    .settings__label {
        display: flex;
        align-items: center;
        font-weight: 500;
        margin-right: 20px;
        white-space: nowrap;
    }
    .settings__field-body {
        display: flex;
        align-items: center;
    }
    .settings__button {
        margin-right: 10px;
    }
    .settings__button_is-tab {
        margin-top: 10px;
    }
    .settings__button_is-full-width {
        width: 100%;
        display: flex;
        align-items: center;
    }
    .settings__columns {
        display: flex;
        width: 100%;
    }
    .settings__column {
        width: 100%;
        &:first-child {
            margin-right: 50px;
        }
    }
    .settings__fractions {
        display: flex;
        margin-top: 10px;
        min-height: 43px;
    }
    .select-container {
        display: flex;
        align-items: center;
        width: 100%;
    }
    .select-container__select {
        width: 70px;
    }
    .select-container__label {
        margin: 0 0 6px 20px;
        white-space: nowrap;
    }
    .tabs-container {
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
    }
    .sub-operations {
        display: flex;
        flex-direction: row;
        gap: 10px;
        margin-bottom: 15px;
    }
    .sub-operation {
        margin-left: 10px;
    }
</style>
